import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useMessage } from '../../hooks/useMessage';
import { printNode } from './printNode';
import styles from './printButton.module.scss';
/**
 * Кнопка «Распечатать».
 *
 * Один вид и одно поведение на весь портал, рядом с выгрузкой в Excel:
 * отчёт почти всегда идёт дальше — на бумаге в дело и на совещание, в
 * книге чтобы дополнить своими колонками.
 */
const PrintButton = ({ source, title, meta, portrait, compact, className }) => {
    const { t } = useTranslation();
    const toast = useMessage();
    const label = String(t('an_print'));
    const run = () => {
        const ok = printNode({
            node: source.current,
            title,
            meta: meta || [],
            landscape: !portrait,
            labels: { printedAt: String(t('an_printed_at')), signature: String(t('an_signature')) }
        });
        /* Всплывающее окно могли заблокировать; молчать нельзя — человек
           нажмёт кнопку ещё дважды и решит, что печать сломана. */
        if (!ok && source.current)
            toast(String(t('an_print_blocked')), 'warn');
    };
    return (_jsxs("button", Object.assign({ type: "button", "data-noprint": true, className: `${styles.btn} ${compact ? styles.compact : ''} ${className || ''}`, title: label, onClick: run }, { children: [_jsx("i", { className: "fa-solid fa-print" }), !compact && _jsx("span", { children: label })] })));
};
export default PrintButton;
